export default __webpack_public_path__ + "static/media/project.98039cfa.jpeg";